/* eslint-disable no-console */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { setOrtCoordinates, loadReports } from '../actions/actions';

class LocationObserver extends React.Component {
  constructor(props) {
    super(props);
    this.updateReports = _.debounce(this.updateReports, 5000);
  }
  componentWillMount() {
    if (typeof navigator !== 'undefined') {
      this.getUserLocation();
      this.updateReports();
    }
  }

  componentDidUpdate() {
    this.updateReports();
  }

  componentWillUnmount() {
    console.info('[LocationObserver] Clearing updates of position');
    clearInterval(this.geolocationInterval);
    clearInterval(this.reportUpdateInterval);
  }

  updateReports() {
    console.log('[UPDATER] Updating Reports');
    this.props.loadReports();
    if (this.reportUpdateInterval) {
      clearInterval(this.reportUpdateInterval);
    }
    this.reportUpdateInterval = setInterval(() => {
      console.log('[UPDATER] Updating Reports');
      this.props.loadReports();
    }, 10000);
  }

  getUserLocation = () => {
    console.info('[LocationObserver] Location Observer Rendering');
    if (this.props.waechter.active && navigator && navigator.geolocation) {
      console.info('[LocationObserver] Wächter is active and Geolocation is supported');
      console.info('[LocationObserver] Triggering Update of position');
      navigator.geolocation.getCurrentPosition(position => {
        console.info('[LocationObserver] Updating current position', position);
        this.props.setOrtCoordinates(position.coords.latitude, position.coords.longitude);
      });
      this.geolocationInterval = setInterval(() => {
        console.info('[LocationObserver] Triggering Update of position');
        navigator.geolocation.getCurrentPosition(position => {
          console.info('[LocationObserver] Updating current position', position);
          this.props.setOrtCoordinates(position.coords.latitude, position.coords.longitude);
        });
      }, 10000);
    }
  };

  render() {
    return null;
  }
}

LocationObserver.propTypes = {
  setOrtCoordinates: PropTypes.func.isRequired,
  loadReports: PropTypes.func.isRequired,
  waechter: PropTypes.shape({
    active: PropTypes.bool.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  const waechter = state.orte.filter(ort => ort.name === 'Mein Wächter')[0];
  return {
    orte: state.orte,
    waechter,
  };
};

const mapDispatchToProps = dispatch => ({
  setOrtCoordinates: (lat, lng) => {
    dispatch(setOrtCoordinates('Mein Wächter', lat, lng));
  },
  loadReports: () => {
    dispatch(loadReports());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationObserver);



// WEBPACK FOOTER //
// ./src/js/components/Updater.js